// Global asset configuration
let globalAssetDomainOverride: string | undefined;

/**
 * Initialize the global asset domain override from Inertia page props
 * This should be called once when the app starts
 */
export function initializeAssetConfig(override?: string) {
  globalAssetDomainOverride = override;
}

/**
 * Get the current asset domain override
 */
export function getAssetDomainOverride(): string | undefined {
  return globalAssetDomainOverride;
}
